import { toast } from "react-toastify";

export default function HandleErrors(err: any) {
  const showErrorToast = (msg: string) => {
    toast.error(msg);
  };

  console.log("err=>:", err);
  if (err.details?.reason) {
    showErrorToast(err.details?.reason);
  } else if (typeof err.detail === "string") {
    showErrorToast(err.detail);
  } else if (typeof err?.message === "object") {
    showErrorToast(err?.message?.[0]);
  } else if (err.message) {
    showErrorToast(err.message);
  } else if (err.detail?.length) {
    showErrorToast(err.detail.join(", "));
  } else if (err.details?.length) {
    showErrorToast(err.details.join(", "));
  } else if (err.detail) {
    showErrorToast(err.detail);
  } else if (err.user?.email) {
    showErrorToast(err.user?.email?.[0]);
  } else if (err && Object.keys(err)) {
    showErrorToast(err[Object.keys(err)[0]][0]);
  } else if (Object.keys(err)?.length !== 0) {
    showErrorToast(String(Object.values(err)[0]));
  } else {
    showErrorToast("خطأ غير متوقع!");
  }
}
